<template>
  <div>
    <mds-page-shell :logo="getProductLogo()" :logo-responsive="getProductLogo()" logo-href="/"
      logo-alt="Back to home page">
      <div class="subscriptionprice-main">
        <div class="subscriptionprice-registration-form-subscribe-selection">
          <div class="subscriptionprice-registration-form-subscribe-selection-container">
            <div v-if="showAlert" class="alert-div">
              <mds-alert class="show-alert" variation="informational"
                title="Discount codes are only applicable to yearly subscriptions, so your discount has been removed. Please select a yearly subscription option to use an offer code"
                tinted @mds-alert-dismissed="CloseAlertBox">
              </mds-alert>
              <div class="text-below-alert">
                Quarterly subscriptions are billed every three months.
              </div>
            </div>
            <div v-else>
              <div class="subscriptionprice-title-for-registration-form">
                <h1 class="subscriptionprice-registration-page-title">
                  Digital subscription selection
                </h1>
              </div>
              <div class="subscriptionprice-registration-top-part-text">
                <p>
                  Select one or more subscriptions below. <br />
                  Annual subscriptions are billed once per year. <br />
                  Quarterly subscriptions are billed every three months.
                </p>
              </div>
            </div>
            <div class="subscriptionprice-registration-top-part-text">
              <p>
                For print subscriptions, please call 1-866-608-9570<br />
                Monday–Friday 8AM–5PM CST.
              </p>
            </div>
            <div class="subscriptionprice-loader" v-if="isLoading">
              <mds-loader aria-label="Medium Loader" size="medium"></mds-loader>
            </div>

            <div v-if="!isLoading">
              <div class="subscriptionprice-registration-form-fields">
                <h1 class="Subscription-newsletter-title">FundInvestor</h1>
              </div>
              <div class="subscriptionprice-registration-border"></div>

              <div class="subscription-selection-type">
                <div class="annual-subscription" v-if="!mfiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MFIAccess" value="accept"
                    :microcopy="getAnnualMonthlyPrice(mfiAnnualSubscriptionPrice)"
                    @click.native.stop="CheckButtonmfiannual()" v-model="mfiannual">${{ mfiAnnualSubscriptionPrice
                    }}/year</mds-checkbox>
                </div>

                <!--discounted price-css-->
                <div class="annual-subscription" v-if="mfiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MFIAccess" value="accept" class="discounted-price-checkbox"
                    :microcopy="getAnnualMonthlyPrice(MFIAccess ? mfiAnnualSubscriptionPrice : mfiAnnualDiscountedPrices)"
                    @click.native.stop="DiscountedCheckButtonmfiannual()" v-model="discountedMfiAnnual">
                    <div class="checkbox-wrapper">
                      <span class="discounted-price">
                        ${{ MFIAccess ? mfiAnnualSubscriptionPrice : mfiAnnualDiscountedPrices }}/year
                      </span>
                      <p v-if="!MFIAccess" class="original-price" v-bind:style="{ textDecoration: 'line-through' }">
                        {{ mfiAnnualOriginalPrices }}/year
                      </p>
                    </div>
                  </mds-checkbox>
                </div>

                <div class="quarterly-subscription">
                  <h1 class="Quarterly-Title">QUARTERLY</h1>
                  <mds-checkbox :disabled="MFIAccess" value="accept" @click.native.stop="CheckButtonmfiquarter()"
                    v-model="mfiquarter">${{ mfiQuterlySubscriptionPrice }}/quarter</mds-checkbox>
                </div>
              </div>
              <div>
                <h1 v-if="!MFIAccess" class="subscription-bottom-text">
                  Save {{ discountPercentage() }}% over quarterly
                </h1>
              </div>

              <div class="subscriptionprice-registration-form-fields">
                <h1 class="Subscription-newsletter-title">StockInvestor</h1>
              </div>
              <div class="subscriptionprice-registration-border"></div>
              <div class="subscription-selection-type">
                <div class="annual-subscription" v-if="!msiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MSIAccess" value="accept"
                    :microcopy="getAnnualMonthlyPrice(msiAnnualSubscriptionPrice)"
                    @click.native.stop="CheckButtonmsiannual()" v-model="msiannual">${{ msiAnnualSubscriptionPrice
                    }}/year</mds-checkbox>
                </div>

                <!--discounted price-css-->
                <div class="annual-subscription" v-if="msiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MSIAccess" value="accept" class="discounted-price-checkbox"
                    :microcopy="getAnnualMonthlyPrice(MSIAccess ? msiAnnualSubscriptionPrice : msiAnnualDiscountedPrices)"
                    @click.native.stop="DiscountedCheckButtonmsiannual()" v-model="discountedMsiAnnual">
                    <div class="checkbox-wrapper">
                      <span class="discounted-price">
                        ${{ MSIAccess ? msiAnnualSubscriptionPrice : msiAnnualDiscountedPrices }}/year
                      </span>
                      <p v-if="!MSIAccess" class="original-price" v-bind:style="{ textDecoration: 'line-through' }">
                        {{ msiAnnualOriginalPrices }}/year
                      </p>
                    </div>
                  </mds-checkbox>
                </div>

                <div class="quarterly-subscription">
                  <h1 class="Quarterly-Title">QUARTERLY</h1>
                  <mds-checkbox :disabled="MSIAccess" value="accept" @click.native.stop="CheckButtonmsiquarter()"
                    v-model="msiquarter">${{ msiQuterlySubscriptionPrice }}/quarter</mds-checkbox>
                </div>
              </div>

              <div>
                <h1 v-if="!MSIAccess" class="subscription-bottom-text">
                  Save {{ discountPercentageForMSI() }}% over quarterly
                </h1>
              </div>

              <div class="subscriptionprice-registration-form-fields">
                <h1 class="Subscription-newsletter-title">DividendInvestor</h1>
              </div>
              <div class="subscriptionprice-registration-border"></div>

              <div class="subscription-selection-type">
                <div class="annual-subscription" v-if="!mdiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MDIAccess" value="accept"
                    :microcopy="getAnnualMonthlyPrice(mdiAnnualSubscriptionPrice)"
                    @click.native.stop="CheckButtonmdiannual()" v-model="mdiannual">${{ mdiAnnualSubscriptionPrice
                    }}/year</mds-checkbox>
                </div>

                <!--discounted price-css-->
                <div class="annual-subscription" v-if="mdiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MDIAccess" value="accept" class="discounted-price-checkbox"
                    :microcopy="getAnnualMonthlyPrice(MDIAccess ? mdiAnnualSubscriptionPrice : mdiAnnualDiscountedPrices)"
                    @click.native.stop="DiscountedCheckButtonmdiannual()" v-model="discountedMdiAnnual">
                    <div class="checkbox-wrapper">
                      <span class="discounted-price">
                        ${{ MDIAccess ? mdiAnnualSubscriptionPrice : mdiAnnualDiscountedPrices }}/year
                      </span>

                      <p v-if="!MDIAccess" class="original-price" v-bind:style="{ textDecoration: 'line-through' }">
                        {{ mdiAnnualOriginalPrices }}/year
                      </p>
                    </div>
                  </mds-checkbox>
                </div>

                <div class="quarterly-subscription">
                  <h1 class="Quarterly-Title">QUARTERLY</h1>
                  <mds-checkbox :disabled="MDIAccess" value="accept" @click.native.stop="CheckButtonmdiquarter()"
                    v-model="mdiquarter">${{ mdiQuterlySubscriptionPrice }}/quarter</mds-checkbox>
                </div>
              </div>
              <div>
                <h1 v-if="!MDIAccess" class="subscription-bottom-text">
                  Save {{ discountPercentageForMDI() }}% over quarterly
                </h1>
              </div>

              <div class="subscriptionprice-registration-form-fields">
                <h1 class="Subscription-newsletter-title">ETFInvestor</h1>
              </div>
              <div class="subscriptionprice-registration-border"></div>

              <div class="subscription-selection-type">
                <div class="annual-subscription" v-if="!meiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MEIAccess" value="accept"
                    :microcopy="getAnnualMonthlyPrice(meiAnnualSubscriptionPrice)"
                    @click.native.stop="CheckButtonetfannual()" v-model="etfannual">${{ meiAnnualSubscriptionPrice
                    }}/year</mds-checkbox>
                </div>

                <!--discounted price-css-->
                <div class="annual-subscription" v-if="meiAnnualDiscounted">
                  <h1 class="Annual-Title">ANNUAL</h1>
                  <mds-checkbox :disabled="MEIAccess" value="accept" class="discounted-price-checkbox"
                    :microcopy="getAnnualMonthlyPrice(MEIAccess ? meiAnnualSubscriptionPrice : meiAnnualDiscountedPrices)"
                    @click.native.stop="DiscountedCheckButtonmeiannual()" v-model="discountedMeiAnnual">
                    <div class="checkbox-wrapper">
                      <span class="discounted-price">
                        ${{ MEIAccess ? meiAnnualSubscriptionPrice : meiAnnualDiscountedPrices }}/year
                      </span>
                      <p v-if="!MEIAccess" class="original-price" v-bind:style="{ textDecoration: 'line-through' }">
                        {{ meiAnnualOriginalPrices }}/year
                      </p>
                    </div>
                  </mds-checkbox>
                </div>

                <div class="quarterly-subscription">
                  <h1 class="Quarterly-Title">QUARTERLY</h1>
                  <mds-checkbox :disabled="MEIAccess" value="accept" @click.native.stop="CheckButtonetfquarter()"
                    v-model="etfquarter">${{ meiQuterlySubscriptionPrice }}/quarter</mds-checkbox>
                </div>
              </div>
              <div>
                <h1 v-if="!MEIAccess" class="subscription-bottom-text">
                  Save {{ discountPercentageForMEI() }}% over quarterly
                </h1>
              </div>
            </div>

            <div class="by-signing-div">
              <p class="by-signing-text">
                <a class="subscription-guarantee-title">The Morningstar Guarantee:</a>
                If you are unhappy with our newsletter(s) for any reason, cancel at any time and we will 
                refund the remaining time left on your subscription. Your satisfaction is our priority.
              </p>
            </div> 

            <div v-if="OfferCodeDIV">
              <div v-if="!isOfferDivVisible" class="have-an-offer-main-div">
                <a href="/" @click.prevent="toggleOfferDiv" class="have-an-offer-text">
                  Have an offer code?
                </a>
                <div class="have-an-offer-text-bottom-border"></div>
              </div>
              <div v-else class="offer-div">
                <!-- Your offer code input or any content you want to show -->
                <div class="offer-input-div">
                  <mds-input v-model="offerCode" size="large" label="Offer Code" placeholder="Enter Code"
                    :error="promoCodeInputError" :error-text="[errorMessage]"></mds-input>
                </div>

                <div class="offer-button-div">
                  <mds-button variation="secondary" size="large" type="button" right-aligned @click="applyOffer"
                    :disabled="isCouponButtonDisabled">
                    Apply</mds-button>
                </div>
              </div>
            </div>

            <div v-if="!OfferCodeDIV" class="after-promocode-apply-div">
              <div>
                <h1 class="after-promo-offer-code">Offer Code</h1>
              </div>
              <div>
                <mds-tag removable @mds-tag-removed="RemovePromocode" size="medium" :text="this.promoname"></mds-tag>
              </div>

              <div>
                <p class="after-promo-code-below-text">
                  This coupon is applicable to yearly subscriptions only. Selecting
                  quarterly for your term will remove any offer codes.
                </p>
              </div>
            </div>

            <div v-if="isAnyQuarterlySelected && isOfferDivVisible && OfferCodeDIV">
              <p class="quarterly-selection-warning">
                Discount codes are applicable to yearly subscriptions only.
                Selecting a quarterly term will remove any offer codes.
              </p>
            </div>
            <div v-else style="margin-top: 54px;"></div>

            <div class="subscriptionprice-registration-button-container">
              <mds-button-container>
                <!-- Icon On Left -->
                <mds-button variation="secondary" size="large" onclick="history.back()">
                  Back
                </mds-button>
                <div class="subcription-cancel-button">
                  <mds-button variation="secondary" size="large" type="button" @click="
                    $router.push({
                      name: 'combined-home',
                      params: { currentproduct: 'Common' },
                    })
                    ">
                    Cancel
                  </mds-button>
                </div>
                <!-- Icon On Both Sides -->
                <div class="subcription-continue-button">
                  <mds-button variation="primary" size="large" type="button" right-aligned
                    :disabled="isNoneSelected || isLoading" @click="ContinueForm">
                    Continue</mds-button>
                </div>
              </mds-button-container>
            </div>
            <div class="subscriptionprice-register-page-bottom"></div>
          </div>
        </div>
      </div>
    </mds-page-shell>
  </div>
</template>

<script>
import MdsPageShell from "@mds/page-shell";
import MdsCheckbox from "@mds/checkbox";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsLoader from "@mds/loader";
import EncryptDecryptMixin from "../../mixins/EncryptDecryptMixin";
import { fetchData } from "@/utilities/API/apiUtility";
import MdsInput from "@mds/input";
import { MdsTag } from "@mds/tag";
import MdsAlert from "@mds/alert";
import { GetSessionData } from "@/utilities/userDataUtility";

export default {
  name: "subscription-selection",
  mixins: [EncryptDecryptMixin],
  components: {
    MdsPageShell,
    MdsCheckbox,
    MdsButton,
    MdsButtonContainer,
    MdsLoader,
    MdsInput,
    MdsTag,
    MdsAlert
  },
  data() {
    return {
      mfiQuterlySubscriptionPrice: null,
      mfiAnnualSubscriptionPrice: null,
      msiQuterlySubscriptionPrice: null,
      msiAnnualSubscriptionPrice: null,
      mdiQuterlySubscriptionPrice: null,
      mdiAnnualSubscriptionPrice: null,
      meiQuterlySubscriptionPrice: null,
      meiAnnualSubscriptionPrice: null,
      paramPromoCode: this.$route.query.offerCode,
      selectedProductCode: this.$route.params.productcode,
      mfiannual: false,
      discountedMfiAnnual: false,
      discountedMsiAnnual: false,
      discountedMeiAnnual: false,
      discountedMdiAnnual: false,
      mfiAnnualDiscounted: false,
      meiAnnualDiscounted: false,
      msiAnnualDiscounted: false,
      mdiAnnualDiscounted: false,
      mfiquarter: false,
      msiannual: false,
      msiquarter: false,
      mdiannual: false,
      mdiquarter: false,
      etfannual: false,
      etfquarter: false,
      isLoading: true,
      MEIAccess: false,
      MDIAccess: false,
      MSIAccess: false,
      MFIAccess: false,
      MFISubscriptionData: null,
      MSISubscriptionData: null,
      MDISubscriptionData: null,
      MEISubscriptionData: null,
      userID: null, // UIM GUID
      displayMsiDiscountMsg: false,
      displayMfiDiscountMsg: false,
      displayMdiDiscountMsg: false,
      displayMeiDiscountMsg: false,
      isOfferDivVisible: false,
      getcachedproductsandprice:
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetCachedProductsAndPrice,
      offerCode: "",
      OfferCodeDIV: true,
      promoname: "",
      discountAppliedProductName: null,
      discountAppliedProductPrice: null,
      errorMessage: "", // Custom error message
      mfiAnnualOriginalPrices: "",
      mfiAnnualDiscountedPrices: "",
      meiAnnualOriginalPrices: "",
      meiAnnualDiscountedPrices: "",
      msiAnnualOriginalPrices: "",
      msiAnnualDiscountedPrices: "",
      mdiAnnualOriginalPrices: "",
      mdiAnnualDiscountedPrices: "",
      promoCodeInputError: false,
      tagremoval: true,
      mfiAnnualPriceId: "",
      mfiQuarterPriceId: "",
      msiAnnualPriceId: "",
      msiQuarterPriceId: "",
      mdiAnnualPriceId: "",
      mdiQuarterPriceId: "",
      etfAnnualPriceId: "",
      etfQuarterPriceId: "",
      mfiDiscountedAnnualPrice: "",
      msiDiscountedAnnualPrice: "",
      mdiDiscountedAnnualPrice: "",
      meiDiscountedAnnualPrice: "",
      Promocode: "",
      ifPromocodeNotApplied: true,
      isPromoCodeValid: null,
      isCouponButtonDisabled: false,
      showAlert: false
    };
  },

  computed: {
    isNoneSelected() {
      return !(
        this.mfiannual ||
        this.mfiquarter ||
        this.discountedMfiAnnual ||
        this.msiannual ||
        this.msiquarter ||
        this.discountedMsiAnnual ||
        this.mdiannual ||
        this.mdiquarter ||
        this.discountedMdiAnnual ||
        this.etfannual ||
        this.etfquarter ||
        this.discountedMeiAnnual
      );
    },
    isAnyAnnualSelected() {
      return [this.mfiannual, this.msiannual, this.mdiannual, this.etfannual].some(Boolean);
    },
    isAnyQuarterlySelected() {
      return [this.mfiquarter, this.msiquarter, this.mdiquarter, this.etfquarter].some(Boolean);
    }
  },

  methods: {
    RemovePromocode() {
      this.mdiAnnualDiscountedPrices = null;
      this.msiAnnualDiscountedPrices = null;
      this.mfiAnnualDiscountedPrices = null;
      this.meiAnnualDiscountedPrices = null;

      this.ifPromocodeNotApplied = true;
      this.OfferCodeDIV = true;
      this.mfiAnnualDiscounted = false;
      this.meiAnnualDiscounted = false;
      this.msiAnnualDiscounted = false;
      this.mdiAnnualDiscounted = false;
      this.getMFISubscriptionPrice();
      this.getMSISubscriptionPrice();
      this.getMDISubscriptionPrice();
      this.getMEISubscriptionPrice();

      this.discountPercentage();
      this.discountPercentageForMDI();
      this.discountPercentageForMSI();
      this.discountPercentageForMEI();

      this.$forceUpdate();
    },

    CloseAlertBox() {
      this.showAlert = false;
    },

    toggleOfferDiv() {
      this.isOfferDivVisible = !this.isOfferDivVisible;
    },
    getProductLogo() {
      var images = require.context("../../../assets/Images", false, /\.svg$/);
      return images("./Common.svg");
    },
    getAnnualMonthlyPrice(AnnualSubscriptionPrice) {
      var monthlyrice = AnnualSubscriptionPrice / 4;
      monthlyrice = (Math.round(monthlyrice * 100) / 100).toFixed(2);
      return "$" + monthlyrice + "/quarter";
    },

    setDatatoLocalStorage(data, productSubscription) {
      data = JSON.stringify(data);
      data = this.Encrypt(data);
      localStorage.setItem(productSubscription, data);
    },
    async getMFISubscriptionPrice() {

      try {
        return fetchData(this.getcachedproductsandprice)
          .then((response) => {
            if (response.data) {
              // Initialize variables for subscription prices
              this.mfiAnnualDiscountedPrices = null;
              this.mfiAnnualSubscriptionPrice = null;
              this.mfiQuterlySubscriptionPrice = null;
              // Loop through the response data
              response.data.forEach((product) => {
                if (product.name === "FundInvestor") {
                  // Loop through the prices to find the "Annual" type
                  product.prices.forEach((price) => {
                    if (price.type === "Annual") {
                      // Set the originalPrice for Annual subscription
                      this.mfiAnnualSubscriptionPrice = price.originalPrice;
                      this.mfiAnnualPriceId = price.id;
                    }
                    // Optionally handle Quarterly price as well, if needed
                    if (price.type === "Quarterly") {
                      this.mfiQuterlySubscriptionPrice = price.originalPrice;
                      this.mfiQuarterPriceId = price.id;
                    }
                  });
                }
              });
            }
          })
          .catch((error) => {
            if (process.env.NODE_ENV == 'development') {
              console.log(error);
            }
          });
      } catch (ex) {
        if (process.env.NODE_ENV == 'development') {
          console.log(ex.message);
        }
      }
    },
    async getMSISubscriptionPrice() {
      try {
        return fetchData(this.getcachedproductsandprice)
          .then((response) => {
            if (response.data) {
              // Initialize variables for subscription prices
              this.msiAnnualDiscountedPrices = null;
              this.msiAnnualSubscriptionPrice = null;
              this.msiQuterlySubscriptionPrice = null;
              // Loop through the response data
              response.data.forEach((product) => {
                if (product.name === "StockInvestor") {
                  // Loop through the prices to find the "Annual" type
                  product.prices.forEach((price) => {
                    if (price.type === "Annual") {
                      // Set the originalPrice for Annual subscription
                      this.msiAnnualSubscriptionPrice = price.originalPrice;
                      this.msiAnnualPriceId = price.id;
                    }
                    // Optionally handle Quarterly price as well, if needed
                    if (price.type === "Quarterly") {
                      this.msiQuterlySubscriptionPrice = price.originalPrice;
                      this.msiQuarterPriceId = price.id;
                    }
                  });
                }
              });
            }
          })
          .catch((error) => {
            if (process.env.NODE_ENV == 'development') {
              console.log(error);
            }
          });
      } catch (ex) {
        if (process.env.NODE_ENV == 'development') {
          console.log(ex.message);
        }
      }
    },
    async getMDISubscriptionPrice() {
      try {
        return (
          fetchData(this.getcachedproductsandprice)
            .then((response) => {
              if (response.data) {
                // Initialize variables for subscription prices
                this.mdiAnnualDiscountedPrices = null;
                this.mdiAnnualSubscriptionPrice = null;
                this.mdiQuterlySubscriptionPrice = null;
                // Loop through the response data
                response.data.forEach((product) => {
                  if (product.name === "DividendInvestor") {
                    // Loop through the prices to find the "Annual" type
                    product.prices.forEach((price) => {
                      if (price.type === "Annual") {
                        // Set the originalPrice for Annual subscription
                        this.mdiAnnualSubscriptionPrice = price.originalPrice;
                        this.mdiAnnualPriceId = price.id;
                      }
                      // Optionally handle Quarterly price as well, if needed
                      if (price.type === "Quarterly") {
                        this.mdiQuterlySubscriptionPrice = price.originalPrice;
                        this.mdiQuarterPriceId = price.id;
                      }
                    });
                  }
                });
              }
            })
            .catch((error) => {
              if (process.env.NODE_ENV == 'development') {
                console.log(error);
              }
            })
        );
      } catch (ex) {
        if (process.env.NODE_ENV == 'development') {
          console.log(ex.message);
        }
      }
    },
    async getMEISubscriptionPrice() {
      try {
        return fetchData(this.getcachedproductsandprice)
          .then((response) => {
            if (response.data) {
              // Initialize variables for subscription prices
              this.meiAnnualDiscountedPrices = null;
              this.meiAnnualSubscriptionPrice = null;
              this.meiQuterlySubscriptionPrice = null;
              // Loop through the response data
              response.data.forEach((product) => {
                if (product.name === "ETFInvestor") {
                  // Loop through the prices to find the "Annual" type
                  product.prices.forEach((price) => {
                    if (price.type === "Annual") {
                      // Set the originalPrice for Annual subscription
                      this.meiAnnualSubscriptionPrice = price.originalPrice;
                      this.etfAnnualPriceId = price.id;
                    }
                    // Optionally handle Quarterly price as well, if needed
                    if (price.type === "Quarterly") {
                      this.meiQuterlySubscriptionPrice = price.originalPrice;
                      this.etfQuarterPriceId = price.id;
                    }
                  });
                }
              });
            }
          })
          .catch((error) => {
            if (process.env.NODE_ENV == 'development') {
              console.log(error);
            }
          });
      } catch (ex) {
        if (process.env.NODE_ENV == 'development') {
          console.log(ex.message);
        }
      }
    },

    async applyOffer() {
      this.promoCodeInputError = false;
      this.isCouponButtonDisabled = true;
      // Fetch the promo codes from the API
      var getCachedPromoCodeUrl =
        process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_GetCachedPromoCodes;

      try {
        const response = await fetchData(getCachedPromoCodeUrl);

        if (response && response.status == 200 && response.data) {
          var results = response.data;

          // Extract only the 'code' values from the response data
          var promoCodes = results
            .filter((promo) => promo.isActive) // Filter active promo codes
            .map((promo) => promo.code); // Get the promo codes only

          // Compare the input offerCode with the promoCodes array
          var isCodeValid = promoCodes.includes(this.offerCode);

          if (isCodeValid) {
            this.isPromoCodeValid = true;
          } else {
            this.isPromoCodeValid = false;
            this.promoCodeInputError = true;
            this.errorMessage = "The provided offer code is invalid or expired.";
            this.isCouponButtonDisabled = false;
          }
        }

        if (this.isPromoCodeValid == true) {
          this.isLoading = true;
          this.isCouponButtonDisabled = false;
          this.displayMfiDiscountMsg = true;
          this.displayMeiDiscountMsg = true;
          this.displayMsiDiscountMsg = true;
          this.displayMdiDiscountMsg = true;
          this.ifPromocodeNotApplied = false;
          // Check if offer code is empty
          if (this.offerCode.trim() === "") {
            // Set the error flag to true
            this.promoCodeInputError = true;
            this.errorMessage = "Please enter a offer code.";
            this.displayMfiDiscountMsg = false;
            this.displayMeiDiscountMsg = false;
            this.displayMsiDiscountMsg = false;
            this.displayMdiDiscountMsg = false;

            this.ifPromocodeNotApplied = true;
          } else {
            // Proceed with API call or other logic if offer code is entered
            this.promoCodeInputError = false; // Reset error if code is provided
            // Your code for applying the offer goes here
          }
          var ApplyPromocodeUrl =
            process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_ApplyPromocode;
          ApplyPromocodeUrl = ApplyPromocodeUrl.replace("{promoCode}", this.offerCode);

          try {
            // Make an API call with the offerCode as a parameter
            const response = await fetchData(ApplyPromocodeUrl);

            // Check if the promo code is invalid or inactive based on the response
            if (response.data === "Invalid or inactive promo code.") {
              this.promoCodeInputError = true;
              this.errorMessage = "The provided offer code is invalid or expired.";
              this.isLoading = false;
              this.displayMfiDiscountMsg = false;
              this.displayMeiDiscountMsg = false;
              this.displayMsiDiscountMsg = false;
              this.displayMdiDiscountMsg = false;

              this.ifPromocodeNotApplied = true;
              return;
            }

            // Hide the promo name div
            this.OfferCodeDIV = false;
            this.promoname = response.data.coupon;
            this.Promocode = response.data.promoCode;

            this.discountAppliedProductNames = [];

            // Iterate through the products and store the required details
            response.data.productPrices.forEach((product) => {
              product.prices.forEach((price) => {
                // If the discount is applied, push the price details to the respective arrays
                if (price.isDiscountApplied) {
                  //this.discountAppliedProductNames.push(product.name);

                  if (product.name == "FundInvestor") {
                    this.mfiDiscountedAnnualPrice = price.id;
                    this.mfiAnnualOriginalPrices = price.originalPrice;
                    this.mfiAnnualDiscountedPrices = price.discountedPrice;
                    this.mfiAnnualDiscounted = true;
                    this.discountedMfiAnnual = true;
                    this.mfiquarter = false;
                    this.discountedMfiAnnual = true;
                    this.mfiannual = false;
                  }
                  if (product.name == "ETFInvestor") {
                    this.meiDiscountedAnnualPrice = price.id;
                    this.meiAnnualOriginalPrices = price.originalPrice;
                    this.meiAnnualDiscountedPrices = price.discountedPrice;
                    this.meiAnnualDiscounted = true;
                    this.discountedMeiAnnual = true;
                    this.etfquarter = false;
                    this.discountedMeiAnnual = true;
                    this.etfannual = false;
                  }
                  if (product.name == "DividendInvestor") {
                    this.mdiDiscountedAnnualPrice = price.id;
                    this.mdiAnnualOriginalPrices = price.originalPrice;
                    this.mdiAnnualDiscountedPrices = price.discountedPrice;
                    this.mdiAnnualDiscounted = true;
                    this.discountedMdiAnnual = true;
                    this.mdiquarter = false;
                    this.discountedMdiAnnual = true;
                    this.mdiannual = false;
                  }
                  if (product.name == "StockInvestor") {
                    this.msiDiscountedAnnualPrice = price.id;
                    this.msiAnnualOriginalPrices = price.originalPrice;
                    this.msiAnnualDiscountedPrices = price.discountedPrice;
                    this.msiAnnualDiscounted = true;
                    this.discountedMsiAnnual = true;
                    this.msiquarter = false;
                    this.discountedMsiAnnual = true;
                    this.msiannual = false;
                  }
                  this.setDatatoLocalStorage(this.offerCode, "promocode");
                } else {
                  // If no discount is applied, push null for both original and discounted prices
                  // this.originalPrices.push(null);
                  // this.discountedPrices.push(null);
                }
                this.isLoading = false;
              });
            });
          } catch (error) {
            // Handle error

            this.isLoading = false;
          }
        }
      } catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.log(error);
        }
      } finally {
        // Additional clean-up if needed
      }
    },

    CheckButtonmfiannual() {
      this.mfiquarter = false;
    },
    DiscountedCheckButtonmfiannual() {
      this.mfiquarter = false;
    },
    CheckButtonmfiquarter() {
      this.mfiannual = false;
      this.discountedMfiAnnual = false;
    },
    CheckButtonmdiannual() {
      this.mdiquarter = false;
    },
    DiscountedCheckButtonmdiannual() {
      this.mdiquarter = false;
    },
    CheckButtonmdiquarter() {
      this.mdiannual = false;
      this.discountedMdiAnnual = false;
    },
    CheckButtonmsiannual() {
      this.msiquarter = false;
    },
    DiscountedCheckButtonmsiannual() {
      this.msiquarter = false;
    },
    CheckButtonmsiquarter() {
      this.msiannual = false;
      this.discountedMsiAnnual = false;
    },
    CheckButtonetfannual() {
      this.etfquarter = false;
    },
    DiscountedCheckButtonmeiannual() {
      this.etfquarter = false;
    },
    CheckButtonetfquarter() {
      this.etfannual = false;
      this.discountedMeiAnnual = false;
    },
    ContinueForm() {
      localStorage.removeItem("MFIProductSubscription");
      localStorage.removeItem("MSIProductSubscription");
      localStorage.removeItem("MDIProductSubscription");
      localStorage.removeItem("MEIProductSubscription");
      if (this.mfiannual) {
        this.discountedMfiAnnual = false;
        const mfiannualsubscriptiondata = {
          priceid: this.mfiAnnualPriceId,
          Price: this.mfiAnnualSubscriptionPrice,
          productname: "FundInvestor",
          subscriptionterm: "Annual Digital",
        };

        if(!this.MFIAccess){
          this.setDatatoLocalStorage(mfiannualsubscriptiondata, "MFIProductSubscription");
          this.$gtag.event("subscription_selection", {
            product: "MFI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        


        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMFIAnnual: "Annual Digital",
              productNameETFAnnual: "FundInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.discountedMfiAnnual) {
        this.mfiannual = false;
        const mfiDiscountedannualsubscriptiondata = {
          priceid: this.mfiDiscountedAnnualPrice,
          promocode: this.Promocode,
          Price: this.mfiAnnualDiscountedPrices,
          originalPrice:this.mfiAnnualSubscriptionPrice,
          productname: "FundInvestor",
          subscriptionterm: "Annual Digital",
        };

        if(!this.MFIAccess){
          this.setDatatoLocalStorage(
            mfiDiscountedannualsubscriptiondata,
            "MFIProductSubscription"
          );

          this.$gtag.event("subscription_selection", {
            product: "MFI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }



        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMFIAnnual: "Annual Digital",
              productNameETFAnnual: "FundInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.msiannual) {
        this.discountedMsiAnnual = false;
        const msiannualsubscriptiondata = {
          priceid: this.msiAnnualPriceId,
          Price: this.msiAnnualSubscriptionPrice,
          productname: "StockInvestor",
          subscriptionterm: "Annual Digital",
        };
        if(!this.MSIAccess){
          this.setDatatoLocalStorage(msiannualsubscriptiondata, "MSIProductSubscription");
          this.$gtag.event("subscription_selection", {
            product: "MSI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        


        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMSIAnnual: "Annual Digital",
              productNameMSIAnnual: "StockInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.discountedMsiAnnual) {
        this.msiannual = false;
        const msiDiscountedannualsubscriptiondata = {
          priceid: this.msiDiscountedAnnualPrice,
          promocode: this.Promocode,
          Price: this.msiAnnualDiscountedPrices,
          originalPrice:this.msiAnnualSubscriptionPrice,
          productname: "StockInvestor",
          subscriptionterm: "Annual Digital",
        };
        if(!this.MSIAccess){
          this.setDatatoLocalStorage(
            msiDiscountedannualsubscriptiondata,
            "MSIProductSubscription"
          );

          this.$gtag.event("subscription_selection", {
            product: "MSI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }



        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMSIAnnual: "Annual Digital",
              productNameMSIAnnual: "StockInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.mdiannual) {
        this.discountedMdiAnnual = false;
        const mdiannualsubscriptiondata = {
          priceid: this.mdiAnnualPriceId,
          Price: this.mdiAnnualSubscriptionPrice,
          productname: "DividendInvestor",
          subscriptionterm: "Annual Digital",
        };

        if(!this.MDIAccess){
          this.setDatatoLocalStorage(mdiannualsubscriptiondata, "MDIProductSubscription");
          this.$gtag.event("subscription_selection", {
            product: "MDI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        


        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMDIAnnual: "Annual Digital",
              productNameMDIAnnual: "DividendInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.discountedMdiAnnual) {
        this.mdiannual = false;
        const mdiDiscountedannualsubscriptiondata = {
          priceid: this.mdiDiscountedAnnualPrice,
          promocode: this.Promocode,
          Price: this.mdiAnnualDiscountedPrices,
          originalPrice:this.mdiAnnualSubscriptionPrice,
          productname: "DividendInvestor",
          subscriptionterm: "Annual Digital",
        };

        if(!this.MDIAccess){
          this.setDatatoLocalStorage(
            mdiDiscountedannualsubscriptiondata,
            "MDIProductSubscription"
          );

          this.$gtag.event("subscription_selection", {
            product: "MDI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }



        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMDIAnnual: "Annual Digital",
              productNameMDIAnnual: "DividendInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.etfannual) {
        this.discountedMeiAnnual = false;
        const etfannualsubscriptiondata = {
          priceid: this.etfAnnualPriceId,
          Price: this.meiAnnualSubscriptionPrice,
          productname: "ETFInvestor",
          subscriptionterm: "Annual Digital",
        };

        if(!this.MEIAccess){
          this.setDatatoLocalStorage(etfannualsubscriptiondata, "MEIProductSubscription");

          this.$gtag.event("subscription_selection", {
            product: "MEI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }
        


        this.$router
          .push({
            name: "billingaddress",
            params: {
              termETFAnnual: "Annual Digital",
              productNameETFAnnual: "ETFInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.discountedMeiAnnual) {
        this.etfannual = false;
        const etfDiscountedannualsubscriptiondata = {
          priceid: this.meiDiscountedAnnualPrice,
          promocode: this.Promocode,
          Price: this.meiAnnualDiscountedPrices,
          originalPrice:this.meiAnnualSubscriptionPrice,
          productname: "ETFInvestor",
          subscriptionterm: "Annual Digital",
        };
        if(!this.MEIAccess){
          this.setDatatoLocalStorage(
            etfDiscountedannualsubscriptiondata,
            "MEIProductSubscription"
          );

          this.$gtag.event("subscription_selection", {
            product: "MEI",
            term: "Annual Digital",
            userid: this.userID,
          });
        }



        this.$router
          .push({
            name: "billingaddress",
            params: {
              termETFAnnual: "Annual Digital",
              productNameETFAnnual: "ETFInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }

      if (this.mfiquarter) {
        const mfiquartersubscriptiondata = {
          priceid: this.mfiQuarterPriceId,
          Price: this.mfiQuterlySubscriptionPrice,
          productname: "FundInvestor",
          subscriptionterm: "Quarterly Digital",
        };
        this.setDatatoLocalStorage(
          mfiquartersubscriptiondata,
          "MFIProductSubscription"
        );

        this.$gtag.event("subscription_selection", {
          product: "MFI",
          term: "Quarterly Digital",
          userid: this.userID,
        });
        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMFIQuarterly: "Quarterly Digital",
              productNameMFIQuarterly: "FundInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }
      if (this.msiquarter) {
        const msiquartersubscriptiondata = {
          priceid: this.msiQuarterPriceId,
          Price: this.msiQuterlySubscriptionPrice,
          productname: "StockInvestor",
          subscriptionterm: "Quarterly Digital",
        };
        this.setDatatoLocalStorage(
          msiquartersubscriptiondata,
          "MSIProductSubscription"
        );

        this.$gtag.event("subscription_selection", {
          product: "MSI",
          term: "Quarterly Digital",
          userid: this.userID,
        });
        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMSIQuarterly: "Quarterly Digital",
              productNameMSIQuarterly: "StockInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }
      if (this.mdiquarter) {
        const mdiquartersubscriptiondata = {
          priceid: this.mdiQuarterPriceId,
          Price: this.mdiQuterlySubscriptionPrice,
          productname: "DividendInvestor",
          subscriptionterm: "Quarterly Digital",
        };
        this.setDatatoLocalStorage(
          mdiquartersubscriptiondata,
          "MDIProductSubscription"
        );

        this.$gtag.event("subscription_selection", {
          product: "MDI",
          term: "Quarterly Digital",
          userid: this.userID,
        });
        this.$router
          .push({
            name: "billingaddress",
            params: {
              termMDIQuarterly: "Quarterly Digital",
              productNameMDIQuarterly: "DividendInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }
      if (this.etfquarter) {
        const etfquartersubscriptiondata = {
          priceid: this.etfQuarterPriceId,
          Price: this.meiQuterlySubscriptionPrice,
          productname: "ETFInvestor",
          subscriptionterm: "Quarterly Digital",
        };
        this.setDatatoLocalStorage(
          etfquartersubscriptiondata,
          "MEIProductSubscription"
        );

        this.$gtag.event("subscription_selection", {
          product: "MEI",
          term: "Quarterly Digital",
          userid: this.userID,
        });
        this.$router
          .push({
            name: "billingaddress",
            params: {
              termETFQuarterly: "Quarterly Digital",
              productNameETFQuarterly: "ETFInvestor",
            },
            query: { offerCode: this.$route.query.offerCode }
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes("Avoided redundant navigation to current location")
            ) {
              if (process.env.NODE_ENV == 'development') {
                console.log(err);
              }
            }
          });
      }
      this.$router
        .push({
          name: "billingaddress",
          params: {
            productcode: this.selectedProductCode,
          },
          query: { offerCode: this.$route.query.offerCode }
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes("Avoided redundant navigation to current location")
          ) {
            if (process.env.NODE_ENV == 'development') {
              console.log(err);
            }
          }
        });
    },
    async getDatafromLocalStorage() {
      this.MEISubscriptionData = this.Decrypt(localStorage.getItem("MEIProductSubscription"));
      if (this.MEISubscriptionData != "" && this.MEISubscriptionData != null) {
        this.MEISubscriptionData = JSON.parse(this.MEISubscriptionData);
        if (this.MEISubscriptionData.Price != null) {
          if (this.MEISubscriptionData.subscriptionterm == "Annual Digital") {
            this.etfannual = true;
            this.discountedMeiAnnual = true;
          } else {
            this.etfquarter = true;
          }
        }
      }

      this.MDISubscriptionData = this.Decrypt(localStorage.getItem("MDIProductSubscription"));
      if (this.MDISubscriptionData != "" && this.MDISubscriptionData != null) {
        this.MDISubscriptionData = JSON.parse(this.MDISubscriptionData);
        if (this.MDISubscriptionData != null) {
          if (this.MDISubscriptionData.subscriptionterm == "Annual Digital") {
            this.mdiannual = true;
            this.discountedMdiAnnual = true;
          } else {
            this.mdiquarter = true;
          }
        }
      }

      this.MSISubscriptionData = this.Decrypt(localStorage.getItem("MSIProductSubscription"));
      if (this.MSISubscriptionData != "" && this.MSISubscriptionData != null) {
        this.MSISubscriptionData = JSON.parse(this.MSISubscriptionData);
        if (this.MSISubscriptionData != null) {
          if (this.MSISubscriptionData.subscriptionterm == "Annual Digital") {
            this.msiannual = true;
            this.discountedMsiAnnual = true;
          } else {
            this.msiquarter = true;
          }
        }
      }

      this.MFISubscriptionData = this.Decrypt(localStorage.getItem("MFIProductSubscription"));
      if (this.MFISubscriptionData != "" && this.MFISubscriptionData != null) {
        this.MFISubscriptionData = JSON.parse(this.MFISubscriptionData);
        if (this.MFISubscriptionData != null) {
          if (this.MFISubscriptionData.subscriptionterm == "Annual Digital") {
            this.mfiannual = true;
            this.discountedMfiAnnual = true;
          } else {
            this.mfiquarter = true;
          }
        }
      }

      if (
        (this.MFISubscriptionData == "" || this.MFISubscriptionData == null) &&
        (this.MSISubscriptionData == "" || this.MSISubscriptionData == null) &&
        (this.MDISubscriptionData == "" || this.MDISubscriptionData == null) &&
        (this.MEISubscriptionData == "" || this.MEISubscriptionData == null)
      ) {
        const selectedProductCodes = this.selectedProductCode.split(",");
        if (selectedProductCodes.includes("MFI")) {
          this.mfiannual = true;
          this.discountedMfiAnnual = true;
        }
        if (selectedProductCodes.includes("MSI")) {
          this.msiannual = true;
          this.discountedMsiAnnual = true;
        }
        if (selectedProductCodes.includes("MDI")) {
          this.mdiannual = true;
          this.discountedMdiAnnual = true;
        }
        if (selectedProductCodes.includes("MEI")) {
          this.etfannual = true;
          this.discountedMeiAnnual = true;
        }
      }
    },

    // Reusable method for calculating discount percentage for any product
    calculateDiscountPercentageForProduct(quarterlyPrice, annualPrice) {
      const parsedQuarterlyPrice = parseFloat(quarterlyPrice);
      const parsedAnnualPrice = parseFloat(annualPrice);

      // Check if either price is NaN
      if (isNaN(parsedQuarterlyPrice) || isNaN(parsedAnnualPrice)) {
        return 0;
      }

      // Calculate yearly cost from quarterly price
      const yearlyQuarterlyPrice = parsedQuarterlyPrice * 4;

      // Calculate the difference and discount percentage
      const priceDifference = yearlyQuarterlyPrice - parsedAnnualPrice;
      const discountPercentage = (priceDifference / yearlyQuarterlyPrice) * 100;

      return Math.round(discountPercentage); // Round the result
    },

    // Method for promocode discount percentage (using original prices)
    calculatePromocodeDiscountPercentageForProduct(quarterlyPrice, annualPrice) {
      const parsedQuarterlyPrice = parseFloat(quarterlyPrice);
      const parsedAnnualPrice = parseFloat(annualPrice);

      // Check if either price is NaN
      if (isNaN(parsedQuarterlyPrice) || isNaN(parsedAnnualPrice)) {
        return 0;
      }

      // Calculate yearly cost from quarterly price
      const yearlyQuarterlyPrice = parsedQuarterlyPrice * 4;

      // Calculate the difference and promocode discount percentage
      const priceDifference = yearlyQuarterlyPrice - parsedAnnualPrice;
      const promocodeDiscountPercentage = (priceDifference / yearlyQuarterlyPrice) * 100;

      return Math.round(promocodeDiscountPercentage); // Round the result
    },

    // Method to get discount percentage for MFI (and other products)
    discountPercentage() {
      // Call reusable method for MFI (or any other product)
      return this.calculateDiscountPercentageForProduct(
        this.mfiQuterlySubscriptionPrice,
        this.mfiAnnualDiscountedPrices ?? this.mfiAnnualSubscriptionPrice
      );
    },

    discountPercentageForMEI() { 
      return this.calculateDiscountPercentageForProduct(
        this.meiQuterlySubscriptionPrice,
        this.meiAnnualDiscountedPrices ?? this.meiAnnualSubscriptionPrice
      );
    },

    discountPercentageForMSI() {
      return this.calculateDiscountPercentageForProduct(
        this.msiQuterlySubscriptionPrice,
        this.msiAnnualDiscountedPrices ?? this.msiAnnualSubscriptionPrice
      );
    },

    discountPercentageForMDI() {
      return this.calculateDiscountPercentageForProduct(
        this.mdiQuterlySubscriptionPrice,
        this.mdiAnnualDiscountedPrices ?? this.mdiAnnualSubscriptionPrice
      );
    },
    RemoveOffer() {
      this.offerCode = "";
      this.RemovePromocode();
      this.showAlert = true;
      window.scrollTo(0, 0);
    }
  },
  async mounted() {
    await this.getDatafromLocalStorage();
    window.scrollTo(0, 0);
    if (this.$store.state.user.LoggedIn) {
      this.productDataRoles = this.$auth0.user["https://morningstar.com/uim_roles"];
      if (this.productDataRoles != undefined && this.productDataRoles != null) {
        this.MEIAccess = this.productDataRoles.includes("EI_MEMBER");
        this.MDIAccess = this.productDataRoles.includes("DI_MEMBER");
        this.MSIAccess = this.productDataRoles.includes("SI_MEMBER");
        this.MFIAccess = this.productDataRoles.includes("FI_MEMBER");
      }
      this.userID = this.$auth0.user["https://morningstar.com/mstar_id"];
    } else {
      // let data = this.Decrypt(localStorage.getItem("u9")); // Get userdetails email from localstorage
      // if (data) {
      //   data = JSON.parse(data);
       const sessionData = await GetSessionData(this.$session);
        const guId = sessionData.UIMId;
        if (guId) {
          this.userID = guId;
        }
      }
    //}
    this.$store.state.layout.isHeaderRequired = false;
    this.$store.state.layout.isFooterRequired = false;

    // Split selectedProductCode and SelectedreferID into arrays
    await this.getMFISubscriptionPrice();
    await this.getMSISubscriptionPrice();
    await this.getMDISubscriptionPrice();
    await this.getMEISubscriptionPrice();

    if(this.paramPromoCode != undefined && this.paramPromoCode != "")
    {
      this.offerCode = this.paramPromoCode;
      await this.applyOffer();
    }
    this.isCouponButtonDisabled = !this.isAnyAnnualSelected;
    this.isLoading = false;
  },
  watch: {
    isAnyAnnualSelected() {
      this.isCouponButtonDisabled = !this.isAnyAnnualSelected;
    },
    isAnyQuarterlySelected() {
      this.isCouponButtonDisabled = !this.isAnyAnnualSelected;
    },
    mfiquarter() {
      if (this.mfiAnnualDiscounted) {
        this.RemoveOffer();
      }
    },
    msiquarter() {
      if (this.msiAnnualDiscounted) {
        this.RemoveOffer();
      }
    },
    mdiquarter() {
      if (this.mdiAnnualDiscounted) {
        this.RemoveOffer();
      }
    },
    etfquarter() {
      if (this.meiAnnualDiscounted) {
        this.RemoveOffer();
      }
    },
    mdiannual() {
      this.showAlert = false;
    },
    msiannual() {
      this.showAlert = false;
    },
    mfiannual() {
      this.showAlert = false;
    },
    meiannual() {
      this.showAlert = false;
    }
  },
};
</script>

<style scoped lang="scss">
.after-promocode-apply-div {
  margin-top: 45px;
  margin-bottom: 55px;
}

.after-promo-offer-code {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  margin-bottom: 8px;
}

.discounted-price {
  margin-right: 6px;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}

.have-an-offer-text {
  color: #1e1e1e;
  font-size: 16px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}

.after-promo-code-below-text {
  height: 41px;
  color: #5e5e5e;
  margin-top: 13px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
}

.quarterly-selection-warning {
  height: 41px;
  color: #5e5e5e;
  margin-top: 13px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  margin-bottom: 26px;
}

.have-an-offer-main-div {
  margin-top: 43px;
  margin-bottom: 60px;
}

.have-an-offer-text.disabled {
  pointer-events: none;
  color: #aaa;
  /* Optional: to show it's disabled visually */
}

.offer-div {
  margin-top: 45px;
  // margin-bottom: 54px;
  display: flex;
}

.offer-input-div {
  width: 280px;
  margin-right: 11px;
}

.offer-button-div {
  margin-top: 28px;
}

.have-an-offer-text-bottom-border {
  width: 114px;
  border: 1px solid #ababab;
}

.subcription-continue-button {
  width: 122px;
  height: 42px;
  margin-left: 10px;
  order: 2;
}

.subcription-cancel-button {
  margin-left: 64px;
}

.subscriptionprice-registration-form-subscribe-selection-container {
  width: 380px;
  margin: 0 auto;
}

.subscriptionprice-main {
  height: 100%;
  min-height: 100vh;
  background: #f2f2f2;
}

.subscriptionprice-loader {
  width: "276px";
  padding-top: 300px;
  height: 632px;
  left: 38.92%;
  right: 37.92%;
}

.subscriptionprice-register-page-bottom {
  background: linear-gradient(360deg, #ffffff 12.47%, rgba(255, 255, 255, 0) 112.75%);
  opacity: 1;
  z-index: 2;
  transform: rotate(180deg);
  height: 50px;
}

.subscriptionprice-registration-form-subscribe-selection {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  background-color: #fff;
  height: 100%;
  min-height: 100vh;
}

.subscriptionprice-registration-page-title {
  margin-top: 0px;
  margin-bottom: 15%;
  height: 40px;
  padding-top: 57px;
  font-weight: 250;
  font-size: 28px;
  line-height: 34px;
}

.subscriptionprice-title-for-registration-form {
  width: 100%;
}

.subscriptionprice-registration-top-part-text {
  margin-top: 5%;
  width: 100%;
  height: 66px;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
}

.text-below-alert {
  width: 100%;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
}

.subscriptionprice-registration-form-fields {
  margin-top: 23px;
  font-size: 10px;
}

.subscriptionprice-registration-border {
  margin-top: 0px;
  width: 100%;
  border-bottom: 1px solid #808080;
}

//Since the top margin wasn’t being used, I commented out the rest of the block too.
.subscriptionprice-registration-button-container {
  height: 48px;
}

.by-signing-text {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
  margin-bottom: 0px;
}

.by-signing-div {
  margin-top: 44px;
  width: 100%;
}

.Subscription-newsletter-title {
  margin-top: 0px;
  margin-bottom: 6px;
  width: 274.24px;
  height: 21px;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
}

.subscription-selection-type {
  display: flex;
  height: 74px;
}

.annual-subscription {
  width: 210px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

.quarterly-subscription {
  width: 190px;
  margin-left: 40px;
}

.Annual-Title {
  margin-top: 8px;
  margin-bottom: 10px;
  margin-left: 25px;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 1.67px;
  text-transform: uppercase;
  color: #1e1e1e;
}

.Quarterly-Title {
  margin-top: 8px;
  margin-bottom: 10px;
  margin-left: 25px;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 1.67px;
  text-transform: uppercase;
  color: #1e1e1e;
}

.subscription-bottom-text {
  width: 284.85px;
  margin-top: 17px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #0077cf;
  height: 16px;
  margin-left: 5.7%;
}

.subscription-guarantee-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
}

.show-alert {
  ::v-deep .mds-alert__title {
    font-weight: 300;
    font-size: 16px;
  }
}

.alert-div {
  padding-top: 37px;
}

@media only screen and (max-width: 480px) {
  .subscriptionprice-registration-form-subscribe-selection-container {
    width: 90%;
    margin: 0 auto;
  }

  .subscriptionprice-registration-page-title {
    padding-top: 28px;
    font-weight: 250;
    font-size: 28px;
    line-height: 34px;
  }

  .subscriptionprice-registration-top-part-text {
    margin-top: 10%;
  }
}
</style>

<style>
.annual-subscription .mds-checkbox__text {
  font-size: 18px;
}

.annual-subscription .mds-checkbox__microcopy {
  font-size: 16px;
}

.quarterly-subscription .mds-checkbox__text {
  font-size: 18px;
}

.quarterly-subscription .mds-checkbox__microcopy {
  font-size: 16px;
}

.annual-subscription .mds-checkbox__visible-wrap {
  box-shadow: none !important;
}

.annual-subscription .mds-checkbox__microcopy {
  padding-top: 3px;
}

.quarterly-subscription .mds-checkbox__microcopy {
  padding-top: 6px;
}

.quarterly-subscription .mds-checkbox__visible-wrap {
  box-shadow: none !important;
}

.offer-input-div>.mds-label.mds-label--large .mds-label__text {
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  margin-bottom: 8px;
}

.discounted-price-checkbox>span>span:nth-child(2)>span {
  color: #5e5e5e;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;

  width: 114;
  height: 21;
}
</style>
